module.exports = __webpack_public_path__ + "static/media/add image.a56d08fe.png";